import NetworkingOperations from "../index";

const LogIn = () => {
	const url = process.env.REACT_APP_LOGIN;

	return NetworkingOperations.post({ url }).then((res) => res);
};

export default LogIn;
